"use client";

import { useEffect } from "react";

import { installBreadcrumbs } from "@/lib/diagnostics/breadcrumbs";

/**
 * Engancha el registro de migas de pan apenas arranca la app.
 *
 * No pinta nada; existe sólo para que los listeners estén puestos ANTES de que
 * el usuario toque algo. Va en el layout raíz porque un crash puede pasar en
 * cualquier pantalla, y lo que se quiere reconstruir es el camino completo hasta
 * ahí — no sólo lo que pasó en la pantalla donde explotó.
 */
export function DiagnosticsListener() {
  useEffect(() => {
    installBreadcrumbs();
  }, []);
  return null;
}
